module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/iron-8ea2c77965b626fa037c45593110e40a.svg";